<div class="flex items-center gap-2.5 p-0.5 rounded-full bg-grape-lighter w-[20px] h-[20px]">
  <sbnb-icon [size]="16" icon="dynamic-pricing-arrow"></sbnb-icon>
</div>
